<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.ManageRole") }}
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="pt-5">
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    v-model="search"
                    v-on:keyup.enter="SearchDataRoleList(search)"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="4" class="pt-3">
                  <v-btn
                    color="green"
                    class="ma-2 white--text"
                  >
                    {{ $t("message.Create") }}
                    <v-icon right>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>

          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-data-table
                :headers="
                  $vuetify.breakpoint.smAndDown ? headersMobile : headers
                "
                :items="ListData"
                hide-default-footer
                style="color: #332f2fde"
                :items-per-page="itemsPerPage"
                :mobile-breakpoint="0"
                :page.sync="page"
                single-line
                hide-details
              >
                <template
                  v-if="!$vuetify.breakpoint.smAndDown"
                  v-slot:item="{ item, index }"
                >
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.roleName }}</td>
                    <td class="header-table-css">{{ item.remark }}</td>
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.createTime) }}
                    </td>
                    <td class="header-table-css">
                      {{ ChangeFormatDate(item.updateTime) }}
                    </td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize"
                        depressed
                        style="width: 120px"
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center">
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="orange"
                        @click="OpenRoleDetailDialog(item.roleID)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                      <template>
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="red"
                          @click="InActiveRole(item.roleID)"
                        >
                          <v-icon dark>mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </template>
                    </td>
                  </tr>
                </template>
                <template v-else v-slot:item="{ item, index }">
                  <tr>
                    <td class="header-table-css">{{ no_run + (index + 1) }}</td>
                    <td class="header-table-css">{{ item.roleName }}</td>
                    <td
                      style="
                        padding-bottom: 5px;
                        display: flex;
                        flex-direction: column-reverse;
                        align-items: center;
                      "
                    >
                      <v-btn
                        :color="GetColor(item.active)"
                        rounded
                        class="text-capitalize"
                        depressed
                        style="width: 120px"
                      >
                        <span :style="{ color: GetColorText(item.active) }">{{
                          item.active == true ? "Active" : "InActive"
                        }}</span>
                      </v-btn>
                    </td>
                    <td style="text-align: center">
                      <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="orange"
                        @click="OpenRoleDetailDialog(item.roleID)"
                      >
                        <v-icon dark> mdi-pencil-outline </v-icon>
                      </v-btn>
                      <template>
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="red"
                          @click="InActiveRole(item.roleID)"
                        >
                          <v-icon dark>mdi-trash-can-outline </v-icon>
                        </v-btn>
                      </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <br />
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    :items="items"
                    label="10/page"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="RoleDetailDialog" persistent width="800">
      <v-card>
        <v-card-title
          class="py-3 px-6 d-flex align-center"
          style="background: #1d2939; color: white"
        >
          <span class="text-h6 font-weight-bold">
            {{ $t("message.ManageRole") }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="CloseRoleDetailDialog()">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="12" md="3" v-if="EditStatus">
              <v-text-field
                type="text"
                :label="$t('message.RoleID')"
                disabled
                v-model="RoleID"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                :label="$t('message.RoleName')"
                v-model="RoleName"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                type="text"
                :label="$t('message.Remark')"
                v-model="Remark"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <span style="font-size: 18px; color: black">{{
            $t("message.Permission")
          }}</span>
          <v-row>
            <v-col v-for="item in permissions" :key="item.id" cols="12" md="3">
              <v-checkbox
                color="primary"
                :label="
                  $t(`message.${item.permissionName}`, item.permissionName)
                "
                v-model="item.active"
                hide-details
              />
            </v-col>
          </v-row>

          <v-row class="d-flex justify-end">
            <v-col cols="12" md="4">
              <v-radio-group row v-model="Active">
                <v-radio :label="$t('message.Active')" value="1"></v-radio>
                <v-radio :label="$t('message.InActive')" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <hr class="ml-2 mr-2 mt-6" />
          <v-card-actions
            style="margin-right: 3%; margin-left: 3%"
            class="pb-6 mt-1"
          >
            <v-spacer></v-spacer>
            <v-btn
              v-if="EditStatus"
              color="success"
              class="mr-2 white--text text-capitalize"
              width="120"
              max-height="35"
              @click="updateRole()"
              >{{ $t("message.Update") }}</v-btn
            >
            <v-btn
              v-else
              color="success"
              class="mr-2 white--text text-capitalize"
              width="120"
              max-height="35"
              @click="updateRole()"
              >{{ $t("message.Add") }}</v-btn
            >
            <v-btn
              class="mr-2 text-capitalize"
              width="120"
              style="background-color: #b9c1c9"
              max-height="35"
              text
              @click="CloseRoleDetailDialog()"
              >{{ $t("message.Cancel") }}</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManageRole",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,
      ListData: [],
      RoleDetailDialog: false,
      EditStatus: false,
      RoleID: 0,
      RoleName: "",
      Remark: "",
      RedemptionStatus: false,
      MyQRStatus: false,
      PreRegisterStatus: false,
      CallLiftStatus: false,
      ManageUserStatus: false,
      TerminalStampStatus: false,
      ParkingLotStatus: false,
      Active: null,
      PermissionMenu: [],
      Permission: [],
      permissions: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.RoleName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Remark"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.CreateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.UpdateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
    headersMobile() {
      return [
        {
          text: "No",
          sortable: false,
          align: "left",
        },
        {
          text: "RoleName",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    // let self = this;
    // await self.GetRoleList();
    // await self.loadPermissionMenu();
  },

  methods: {
    GetRoleList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    SearchDataRoleList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perPage: self.itemsPerPage,
      };
      axios
        .post(`${self.url}Management/getDatRoleList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    CloseRoleDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RoleID = 0;
      self.RoleName = "";
      self.Remark = "";
      self.RedemptionStatus = false;
      self.MyQRStatus = false;
      self.PreRegisterStatus = false;
      self.CallLiftStatus = false;
      self.ManageUserStatus = false;
      self.TerminalStampStatus = false;
      self.Active = null;
      self.RoleDetailDialog = false;
    },

    OpenRoleDetailDialog(id) {
      let self = this;
      if (id != 0) {
        self.LoadingDialog = true;
        let temp = {
          roleID: id,
        };
        axios
          .post(`${self.url}Management/getDatRoleByRoleID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.BindingDataRole(response.data.data);
              self.LoadingDialog = false;
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          });
      }
    },

    loadPermissionMenu() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Management/loadPermissionMenu`)
        .then(function (response) {
          if (response.data.status == 0) {
            self.permissions = response.data.data;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 500,
            text: error.response.data.message,
          });
        });
    },

    OpenAddRoleDetailDialog() {
      let self = this;
      self.EditStatus = false;
      self.RoleID = 0;
      self.RoleName = "";
      self.Remark = "";
      if (!self.PermissionMenu || self.PermissionMenu.length === 0) {
        axios.get(`${self.url}Management/loadPermissionMenu`).then((res) => {
          self.PermissionMenu = res.data.data || [];
          self.permissions = self.PermissionMenu.map((menu) => ({
            id: menu.id,
            permissionName: menu.permissionName,
            active: false,
          }));

          self.Active = "1";
          self.RoleDetailDialog = true;
        });
        return;
      }
      self.permissions = self.PermissionMenu.map((menu) => ({
        id: menu.id,
        permissionName: menu.permissionName,
        active: false,
      }));

      self.Active = "1";
      self.RoleDetailDialog = true;
    },

    BindingDataRole(data) {
      let self = this;
      self.EditStatus = true;
      self.RoleID = data.roleID;
      self.RoleName = data.roleName;
      self.Remark = data.remark;
      const permission = data.permission || {};
      const permissionMenu = data.permissionMenu || [];

      const keyMap = {
        Redemption: "redemption",
        MyQR: "qr",
        PreRegister: "preRegister",
        CallLift: "callLift",
        ManageUser: "manageUser",
        TerminalStamp: "terminalStamp",
        ParkingLot: "parkingLot",
      };

      self.permissions = permissionMenu.map((menu) => ({
        id: menu.id,
        permissionName: menu.permissionName,
        active: !!permission[keyMap[menu.permissionName]],
      }));

      self.Active = data.active === true ? "1" : "2";
      self.RoleDetailDialog = true;
    },

    async updateRole() {
      let self = this;
      self.LoadingDialog = true;
      try {
        const keyMap = {
          Redemption: "redemption",
          MyQR: "qr",
          PreRegister: "preRegister",
          CallLift: "callLift",
          ManageUser: "manageUser",
          TerminalStamp: "terminalStamp",
          ParkingLot: "parkingLot",
        };

        const permissionPayload = {};
        self.permissions.forEach((p) => {
          const key = keyMap[p.permissionName];
          if (key) {
            permissionPayload[key] = p.active;
          }
        });

        const payload = {
          roleName: self.RoleName,
          remark: self.Remark,
          permission: permissionPayload,
          active:
            self.Active === "1" ? true : self.Active === "2" ? false : null,
        };
        const url = self.EditStatus
          ? `${self.url}Management/updateRole`
          : `${self.url}Management/addRole`;
        if (self.EditStatus) {
          payload.roleID = self.RoleID;
        }
        const res = await axios.post(url, payload);
        if (res?.data?.status === 0) {
          Swal.fire({
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          self.CloseRoleDetailDialog();
          self.GetRoleList();
          if (!self.EditStatus) {
            self.page = 1;
          }
        } else {
          throw new Error(res?.data?.message || "Save failed");
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          width: 500,
          text: error?.response?.data?.message || error.message || "Error",
        });
      } finally {
        self.LoadingDialog = false;
      }
    },

    InActiveRole(id) {
      let self = this;
      if (id != 0) {
        let temp = {
          roleID: id,
        };
        axios
          .post(`${self.url}Management/inActiveRoleByRoleID`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              Swal.fire({
                icon: "success",
                title: "Success",
                showConfirmButton: false,
                timer: 1500,
              });
              self.GetRoleList();
            }
            self.LoadingDialog = false;
          })
          .catch(function (error) {
            self.LoadingDialog = false;
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 500,
              text: error.response.data.message,
            });
          });
      }
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}
</style>
  